<template>
  <svg
    width="14px"
    height="10px"
    viewBox="0 0 14 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="link_backwards" transform="translate(-1.000000, -7.000000)" fill="currentColor">
        <g id="Actions-/-Navigation-/-arrow--left-/-16" transform="translate(0.000000, 4.000000)">
          <polygon id="Fill" points="6.7 12.3 2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ArrowLeft'
};
</script>
